import { actionCreatorFactory } from 'typescript-fsa'
import { Clock } from '../../types'

const actionCreator = actionCreatorFactory()

export const updateClock = actionCreator<Partial<Clock>>('updateClock')
